// ¿Ha podido cargar la iconfont?
//
// El buscador pinta dos iconos —el calendario y la flecha de volver— con `icomoon`, una fuente
// que el CSS pide con URL absoluta a renfeviajes. Dentro de renfeviajes eso va bien. En la
// landing de un tercero NO: una fuente es una petición de origen cruzado, ese fichero no manda
// `Access-Control-Allow-Origin`, y el navegador la bloquea. Medido en una landing servida desde
// otro puerto: `icomoon.woff` y `icomoon.ttf` fallan con ERR_FAILED y los dos iconos salen como
// cuadraditos.
//
// Cuando eso pasa se marca el widget con `rvb-sin-iconfont` y el CSS pinta esos dos iconos con
// sus propios contornos, sacados de la misma fuente. Si la fuente carga —el caso de la home y
// el de cualquier landing del mismo dominio— aquí no pasa nada y todo se ve como siempre.
//
// La comprobación se hace UNA vez por página, no por instancia: la fuente es del documento.

/** El carácter del calendario, que es lo que hay que pedirle a la fuente para que la baje. */
const UNA_LETRA = ''
const FAMILIA = 'icomoon'

let prometido = null

/**
 * @returns {Promise<boolean>} true si la fuente está disponible
 */
function comprobar () {
  if (prometido) return prometido

  prometido = (async () => {
    // Sin la API de fuentes no hay forma de saberlo. Se da por buena: es lo que pasaba antes
    // de todo esto, y un navegador así tampoco entiende `mask`.
    if (typeof document === 'undefined' || !document.fonts || !document.fonts.load) return true

    try {
      // `load` fuerza la descarga: hasta que algo la usa, el navegador ni lo intenta.
      const caras = await document.fonts.load('1em "' + FAMILIA + '"', UNA_LETRA)
      if (!caras || !caras.length) return false
      return caras.some((cara) => 'error' !== cara.status)
    } catch (e) {
      return false
    }
  })()

  return prometido
}

/**
 * De dónde se pide la iconfont. Está escrito en el `@font-face` que genera el bloque FUENTES de
 * scripts/f1-widget/generar-css.js, con URL absoluta: la fuente sale SIEMPRE de ahí, venga el
 * widget de donde venga. Si algún día se mueve, hay que cambiarlo en los dos sitios.
 */
const ORIGEN_DE_LA_FUENTE = 'https://renfeviajes.renfe.com'

/**
 * ¿Está la página en otro dominio que la fuente? Entonces está condenada: una fuente es
 * petición de origen cruzado y ese fichero no manda `Allow-Origin`.
 *
 * Se mira contra el origen de LA FUENTE y no contra el del servicio, que es lo que se hacía
 * antes y dejaba pasar el caso más común: una landing servida desde el mismo dominio que la
 * aplicación —que es justo el de Corporate Benefits— creía que la fuente iba a cargar, la
 * pedía, y dejaba dos ERR_FAILED en la consola del cliente antes de acabar pintando los
 * iconos con sus contornos.
 */
function vaAFallarSeguro () {
  if (typeof location === 'undefined') return false
  return location.origin !== ORIGEN_DE_LA_FUENTE
}

/**
 * Marca los elementos si la fuente no está, para que el CSS use los contornos de repuesto.
 * @param {Array<Element>} elementos  la raíz del widget y su contenedor de overlays
 */
export function vigilarIconfont (elementos) {
  const marcar = () => elementos.filter(Boolean).forEach((el) => el.classList.add('rvb-sin-iconfont'))

  // Fuera de renfeviajes no se intenta siquiera: se ahorran dos peticiones que van a fallar,
  // dos errores en la consola de la landing —que no son suyos y despistan— y el parpadeo de
  // los cuadraditos mientras el navegador lo descubre.
  if (vaAFallarSeguro()) { marcar(); return }

  comprobar().then((hayFuente) => { if (!hayFuente) marcar() })
}
